var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuRoadmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.92193,
    y: 1.92193,
    width: 46.1562,
    height: 46.1562,
    rx: 6.07807,
    stroke: "white",
    strokeWidth: 2.15615
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_2849)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1354_2849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2578 33.9844C39.4295 33.9844 40.3788 34.9337 40.3788 36.1054C40.3788 37.2772 39.4295 38.2265 38.2578 38.2265C37.3382 38.2265 36.5669 37.648 36.2702 36.8322C36.1812 36.6097 36.1367 36.3576 36.1367 36.1054C36.1367 35.8384 36.1812 35.5863 36.2702 35.349C36.5817 34.548 37.353 33.9844 38.2578 33.9844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0469 35.6606H35.144C35.1292 35.809 35.1143 35.9425 35.1143 36.0908C35.1143 36.2391 35.1292 36.3874 35.144 36.5209H22.0469C22.0617 36.3726 22.0765 36.2391 22.0765 36.0908C22.0765 35.9573 22.0617 35.809 22.0469 35.6606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9016 35.349C20.9906 35.5863 21.0351 35.8384 21.0351 36.1054C21.0351 36.3724 20.9906 36.6246 20.9016 36.8619C20.5901 37.6628 19.8188 38.2265 18.914 38.2265C18.0092 38.2265 17.2231 37.648 16.9265 36.8322C16.8375 36.6097 16.793 36.3576 16.793 36.1054C16.793 35.8384 16.8375 35.5863 16.9265 35.349C17.2379 34.548 18.0092 33.9844 18.914 33.9844C19.8188 33.9844 20.5901 34.548 20.9016 35.349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3718 23.8389H20.7411C20.7263 23.9872 20.7115 24.1207 20.7115 24.269C20.7115 24.4173 20.7263 24.5657 20.7411 24.6992H15.3718C12.3459 24.6992 9.89856 27.1614 9.89856 30.1724C9.89856 33.1834 12.3608 35.6456 15.3718 35.6456H15.8019C15.7871 35.7939 15.7722 35.9274 15.7722 36.0757C15.7722 36.224 15.7871 36.3724 15.8019 36.5059H15.3718C11.8713 36.5059 9.02344 33.658 9.02344 30.1575C9.02344 26.657 11.8713 23.8389 15.3718 23.8389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9757 24.2841C25.9757 24.5363 25.9312 24.7884 25.8422 25.0109C25.8422 25.0208 25.8373 25.0307 25.8274 25.0406C25.5159 25.8416 24.7446 26.4052 23.8398 26.4052C22.935 26.4052 22.1637 25.8416 21.8522 25.0406C21.7632 24.8033 21.7188 24.5511 21.7188 24.2841C21.7188 24.0172 21.7632 23.765 21.8522 23.5277C22.1637 22.7267 22.935 22.1631 23.8398 22.1631C24.7446 22.1631 25.5159 22.7267 25.8274 23.5277C25.9312 23.7502 25.9757 24.0172 25.9757 24.2841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3381 12.0176C35.8386 12.0176 38.6864 14.8654 38.6864 18.3659C38.6864 21.8664 35.8386 24.7142 32.3381 24.7142H26.9688C26.9836 24.5659 26.9984 24.4324 26.9984 24.2841C26.9984 24.1358 26.9836 23.9874 26.9688 23.8539H32.3381C35.364 23.8539 37.8113 21.3917 37.8113 18.3807C37.8113 15.3697 35.3491 12.9075 32.3381 12.9075H30.6472C30.6621 12.7592 30.6769 12.6257 30.6769 12.4774C30.6769 12.3291 30.6621 12.1807 30.6472 12.0472L32.3381 12.0176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5909 12.0176H24.4038C24.389 12.1659 24.3742 12.2994 24.3742 12.4477C24.3742 12.596 24.389 12.7444 24.4038 12.8779H12.9531C13.1608 12.6109 13.3684 12.3142 13.5909 12.0176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6554 12.4477C29.6554 12.6999 29.6109 12.952 29.5219 13.1745C29.5219 13.1844 29.5169 13.1943 29.507 13.2042C29.1956 14.0051 28.4243 14.5688 27.5195 14.5688C26.6147 14.5688 25.8434 14.0051 25.5319 13.2042C25.4429 12.9669 25.3984 12.7147 25.3984 12.4477C25.3984 12.1956 25.4429 11.9434 25.5319 11.7209C25.8286 10.9051 26.6147 10.3267 27.5195 10.3267C28.4243 10.3267 29.1956 10.8903 29.507 11.6913C29.507 11.7061 29.5219 11.7061 29.5219 11.7209C29.6109 11.9582 29.6554 12.1956 29.6554 12.4477Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_2849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.7516,
    height: 31.2642,
    fill: "white",
    transform: "translate(9.36328 8.92969)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1354_2849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.356,
    height: 27.9,
    fill: "white",
    transform: "translate(9.02344 10.3267)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuRoadmap);
export default __webpack_public_path__ + "static/media/icon_menu_roadmap.5ba8b0949ec7182e1b0475975384ce65.svg";
export { ForwardRef as ReactComponent };